import React from 'react';
import { Route, BrowserRouter as Router} from 'react-router-dom';
import Home from './Pages/Home';
import SignForm from './Pages/SignForm';
import Header from './Components/Header';
import './App.css';
import ContactSection from './Components/ContactSection';

const App = () => {
  return (
      <Router>
          <Header/>
          <Route path='/' exact component={Home}/>
          <Route path='/signform' component={SignForm}/>
          <ContactSection/>
      </Router>
  );
}

export default App;
